import { Zone } from "../zone.js";
class InvalidZone extends Zone {
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
  /** @override **/
  get name() {
    return this._zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  constructor(_zoneName) {
    super();
    this._zoneName = _zoneName;
    Object.setPrototypeOf(this, InvalidZone.prototype);
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  offsetName() {
    return null;
  }
}
export {
  InvalidZone
};
